const state = {
  isLoading: false,
};
const getters = {
  isLoadingGet: (state) => state.isLoading,
};
const actions = {
  setLoading({ commit }, payload) {
    commit("SET_LOADING", payload);
  },
};
const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
